export default "__VITE_ASSET__CTxYNpsA__"